import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedOvw202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_ovw_202606",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 64251,
  clicks: 1354,
  adsSpendDollars: 4900,
  budgetDollars: 4900,
  salesDollars: 26652,
  bestEstimateRoas: 5.44,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 1,
  newCustomersAcquired: 66,
  reorderConversions: 30,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
